import { i18n } from 'shared/library/i18n/init-i18n';
import type { ToastOptions, ToastProps } from 'shared/library/notify/index';
import { monitoring } from 'shared/library/monitoring';

let nextToastId = 0;

export function success(props?: string | ToastOptions) {
  return showNotification('success', propsFromOptions(props));
}

export function error(props: string | ToastOptions | undefined = undefined, hint: string) {
  const options = propsFromOptions(props);

  monitoring.Sentry.addBreadcrumb({
    message: options.description || 'Error notification',
    category: 'notification',
    level: 'info',
    data: {
      hint,
      ...options,
    },
  });

  return showNotification('error', options);
}

function showNotification(type: ToastProps['type'], options: ToastOptions): string | number {
  // Reserve the ID synchronously, before the notification UI has been downloaded.
  const id = `getapet-notification-${++nextToastId}`;
  if (typeof window === 'undefined') return id;

  void import('./toaster.web')
    .then(({ showToast }) => showToast({ ...options, id, type }))
    .catch((cause) => {
      monitoring.Sentry.captureException(cause);
      const title = options.title ?? i18n.t(`common:notify_${type}_title`);
      const description = options.description ?? i18n.t(`common:notify_${type}_description`);
      window.alert(`${title}\n\n${description}`);
    });

  return id;
}

function propsFromOptions(options?: string | ToastOptions): ToastOptions {
  if (!options) {
    return {};
  }

  if (typeof options === 'string') {
    return { description: options };
  }

  return options;
}

export const notify = {
  success,
  error,
};
